import ErrorStatus from '$shared/constants/ErrorStatus';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { formatString } from '$shared/helpers/utils';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

export class BaseError {
  protected readonly type: string;

  constructor(type: string) {
    this.type = type;
  }

  public create(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToCreateInfo),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.PermissionMissingToCreateInfo),
        true
      ),
      [ErrorStatus.Conflict]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToCreateInfo),
        true,
        false,
        [UIErrorMessage.DeaNumberAlreadyRegistered]
      )
    };
  }

  public patch(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToUpdateInfo),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.PermissionMissingToUpdateInfo),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToUpdateInfo),
        true
      )
    };
  }

  public delete(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToDeleteInfo),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.PermissionMissingToDeleteInfo),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToDeleteInfo),
        true
      )
    };
  }

  public get(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToGetInfo),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.PermissionMissingToGetInfo),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToGetInfo),
        true
      )
    };
  }

  public getList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToGetList),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.PermissionMissingToGetList),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToGetList),
        true
      )
    };
  }

  protected parseErrorMessage(message: string): string {
    return formatString(message, this.type || '');
  }
}
